import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from '@/components/Icons/ArrowLeft';
import { goToPreviousPage } from '@/utils/global';

interface Props {
  title: string;
  scrollProgress: number;
}

export const SubscriptionMobileHeader: React.FC<Props> = ({
  title,
  scrollProgress,
}) => {
  const { t } = useTranslation();

  return (
    <div className="relative flex w-full items-center md:hidden">
      <button
        type="button"
        onClick={goToPreviousPage}
        aria-label={t('global.back')}
        className="flex size-6 shrink-0 cursor-pointer items-center justify-center text-foreground"
      >
        <ArrowLeft />
      </button>
      <h2
        style={{ opacity: scrollProgress }}
        className="pointer-events-none absolute left-1/2 -translate-x-1/2 text-callout-16 text-foreground"
      >
        {title}
      </h2>
    </div>
  );
};

export const SubscriptionPageTitle: React.FC<Props> = ({
  title,
  scrollProgress,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <h1
        style={{ opacity: 1 - scrollProgress }}
        className="pt-1 text-[24px]/[30px] font-semibold text-foreground transition-opacity duration-75 md:hidden"
      >
        {title}
      </h1>
      <div className="hidden items-center gap-2 md:flex">
        <button
          type="button"
          onClick={goToPreviousPage}
          aria-label={t('global.back')}
          className="flex size-6 shrink-0 cursor-pointer items-center justify-center text-foreground"
        >
          <ArrowLeft />
        </button>
        <h1 className="text-title-24 text-foreground">{title}</h1>
      </div>
    </>
  );
};
